<template>
  <td :colspan="colspan" :style="'width:' + width + '%; min-width:' + width + '%; max-width:' + width + '%; text-align:' + textAlign">
    <slot/>   
  </td> 
</template>

<script>
export default {
  props : {
    width : { default : '5' },
    textAlign : { default : 'left '},
    colspan : { default : '1'}
  }
}
</script>

<style>

</style>